import { useRef, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import MemberCard from '../components/MemberCard';
import '../styles/Profile.css';
import CommonButton from '../components/CommonButton';
import { getMemberById } from '../services/api/memberService';
import { FaDownload } from 'react-icons/fa';

const ProfilePage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [member, setMember] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        console.log(user);
        if (!user) {
          navigate('/login');
          return;
        }

        // --- Ambil data member
        const member = await getMemberById(id);
        if (!member) {
          console.error('Member not found');
          navigate('/profile');
          return;
        }

        setMember(member);
      } catch (err) {
        console.error('Failed to fetch member data:', err);
      }
    };

    fetchData();
  }, [id, navigate]);

  const handleEdit = () => navigate(`/edit-member/${id}`, {
    state: { from: `/profile/${id}` }
  });

  return (
    <div className="profile-container">
      <div className="profile-header">
        <h2>{member?.full_name}</h2>
        {/* <button><FaDownload /></button> */}
      </div>
      {member ? (
        <MemberCard member={member} />
      ) : (
        <p>No Data</p>
      )}
      <CommonButton onClick={handleEdit}>Edit Profile</CommonButton>
    </div>
  );
};

export default ProfilePage;